import { FilterProtocolOverrideDTO } from "../DTO/filterProtocolOverrideDTO";
import { FieldDefinition } from "./fieldDefinition";
import { FilterProtocol } from "./filterProtocol";
import { FilterRule } from "./filterRule";
import { FilterRuleDefinition } from "./filterRuleDefinition";
import { FilterOverride } from "./moovStepConfiguration";

export class FilterProtocolOverride{
    public sequenceNo!: number;
    public filterRules!: FilterRule[];
    public filterOr!: boolean;

    public filterInfo:string='';

    //only used for UI purposes=>do not serialize
    public filterProtocol!: FilterProtocol; //TODO don't forget to set after loading

    constructor(){
        this.filterRules = new Array();
    }

    public relateFilterRuleDefinitionsAndFieldDefinitions(filterRuleDefinitions:FilterRuleDefinition[], fieldDefinitions:FieldDefinition[]){
        this.filterRules.forEach(fr=>{
            fr.filterRuleDefinition=filterRuleDefinitions.find(frd=>frd.id==fr.filterRuleDefinitionId)!;
            fr.createInputField(fieldDefinitions);
            this.filterInfo += fr.inputField?.name + '; ';
        });
    }

    public updateFilterInfo(){
        this.filterRules.forEach(fr=>{
            this.filterInfo += fr.inputField?.name + '; ';
        });
    }

    get filterOverrideJSON(){
        return JSON.stringify(FilterProtocolOverride.mapToDTO(this));
    }

    get filterOverrideData(){
        let filterOverride = new FilterOverride();
        filterOverride.protocolId=this.filterProtocol?.id;
        filterOverride.value=this.filterOverrideJSON;
        return filterOverride;
    }

    get inputFieldNames():string[]{
        //in lower case for duplicate comparison
        return this.filterRules.map(fr=>fr.inputField.name.toLowerCase());
    }

    public static mapFromDTO(param:FilterProtocolOverrideDTO):FilterProtocolOverride{ 
        if (!param) throw new Error("parameter is null")
        let obj = new FilterProtocolOverride();
        try
        {
            obj.sequenceNo = param.sequenceNo;
            obj.filterOr = param.filterOr;
            obj.filterRules = param.filterRules.map(fr=>FilterRule.mapFromDTO(fr));
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:FilterProtocolOverride):FilterProtocolOverrideDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new FilterProtocolOverrideDTO();
        try
        {
            dto.sequenceNo = param.sequenceNo;
            dto.filterOr = param.filterOr;
            dto.filterRules = param.filterRules.map(fr=>FilterRule.mapToDTO(fr));
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
}